<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{ (buildingForm.get('aptUnion')?.value ? 'modules.clients.associations.buildingDialog.title.union' : 'modules.clients.associations.buildingDialog.title.common') | translate }}</div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <form [formGroup]="buildingForm" autocomplete="off" class="dialog-form scroll-content-padding df-c gap15">
        <mat-form-field *ngIf="buildingForm.get('aptUnion')?.value"
                        appearance="outline" class="no-padding full-width" floatLabel="always">
            <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.name' | translate }}</mat-label>
            <input autocomplete="chrome-off"
                   formControlName="name"
                   matInput
                   type="text">
        </mat-form-field>

        <ng-container *ngIf="!buildingForm.get('aptUnion')?.value">
            <div class="df gap20">
                <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
                    <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.street' | translate }}</mat-label>
                    <input [matAutocomplete]="streetsAutocomplete" autocomplete="chrome-off" formControlName="street"
                           matInput type="text">
                    <mat-autocomplete #streetsAutocomplete="matAutocomplete" (optionSelected)="streetIsSelected()" [displayWith]="displayStreetFn" class="custom-autocomplete-panel">
                        <mat-option *ngFor="let street of streets$ | async" [value]="street" class="multiline-option">
                            <span>{{ street.name }}</span>
                            <span>{{ 'common.streetTypes.' + street.type | translate }}</span>
                        </mat-option>
                    </mat-autocomplete>
                    <div class="field-action-button">
                        <button (click)="openListDialog()" class="item-action-button gray">
                            <mat-icon>list</mat-icon>
                        </button>
                    </div>
                </mat-form-field>

                <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 150px; min-width: 150px; max-width: 150px;">
                    <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.number' | translate }}</mat-label>
                    <input autocomplete="chrome-off" formControlName="number" matInput type="text">
                </mat-form-field>
            </div>

            <mat-divider></mat-divider>

            <div class="dialog-subtitle-label df jc-sb ai-c">
                <label>{{ 'modules.clients.associations.buildingDialog.labels.entrances' | translate }}</label>
                <span (click)="addFormArrayItem()" class="add-row">{{ 'common.addItem' | translate }}</span>
            </div>
        </ng-container>
    </form>

    <form #scrollableContent [formGroup]="entrancesForm" autocomplete="off" class="dialog-form scrollable" *ngIf="!buildingForm.get('aptUnion')?.value">
        <div *ngFor="let entranceFormControl of getControls(); let i = index"
             class="form-array-controls-container scroll-content-padding"
             formArrayName="entrancesFormControls">
            <div [formGroupName]="i" class="df-c gap10">
                <div class="full-width df gap20">
                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 120px; min-width: 120px; max-width: 120px">
                        <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.entranceType' | translate }}</mat-label>
                        <mat-select class="select-panel" disableOptionCentering="true" formControlName="entranceType" panelClass="dialog-select-panel">
                            <mat-option [value]="'ENTRANCE'">{{ 'modules.clients.associations.entranceTypes.ENTRANCE' | translate }}</mat-option>
                            <mat-option [value]="'SECTION'">{{ 'modules.clients.associations.entranceTypes.SECTION' | translate }}</mat-option>
                            <mat-option [value]="'HOUSING'">{{ 'modules.clients.associations.entranceTypes.HOUSING' | translate }}</mat-option>
                            <mat-option [value]="'FRONT'">{{ 'modules.clients.associations.entranceTypes.FRONT' | translate }}</mat-option>
                            <mat-option [value]="'PARKING'">{{ 'modules.clients.associations.entranceTypes.PARKING' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <input formControlName="id" hidden matInput type="text">

                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 120px; min-width: 120px; max-width: 120px">
                        <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.entranceNumber' | translate }}</mat-label>
                        <input formControlName="entranceNumber" matInput type="text">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 120px; min-width: 120px; max-width: 120px">
                        <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.firstFloor' | translate }}</mat-label>
                        <input formControlName="firstFloor" matInput type="number">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 120px; min-width: 120px; max-width: 120px">
                        <mat-label>{{ 'modules.clients.associations.buildingDialog.labels.lastFloor' | translate }}</mat-label>
                        <input formControlName="lastFloor" matInput type="number">
                    </mat-form-field>

                    <div class="grow df jc-e ai-c">
                        <button (click)="deleteFormArrayItem(i)" class="default-button delete-button">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
    </form>
</div>
<div class="buttons-row df jc-e ai-c">
    <button (click)="submitForm()" [disabled]="buildingForm.invalid || (!buildingForm.get('aptUnion')?.value && entrancesForm.invalid)" class="default-button apply-button">
        {{ 'common.save' | translate }}
    </button>
</div>

